module.exports = __webpack_public_path__ + "img/star-ai-bg@3x.2b0364e3.png";